import styled from 'styled-components'

import { Trend } from '@root/entities/trend'
import {
  AmountNativeFormatted,
  PnlUsdFormatted,
} from '@root/shared/core/format'

import type BigNumber from 'bignumber.js'

export const AnalysisPnlValue = (props: {
  pnl: BigNumber
  currencySign: string
  balanceType: 'usd' | 'native'
}) => {
  const trend = Trend.of(props.pnl)
  return (
    <Root $trend={trend}>
      {props.balanceType === 'usd' ? (
        <PnlUsdFormatted pnl={props.pnl} />
      ) : (
        <AmountNativeFormatted
          amount={props.pnl}
          currency={props.currencySign}
        />
      )}
    </Root>
  )
}
const Root = styled.div<{ $trend: Trend.Trend }>`
  color: ${(x) => trendColor[x.$trend]};
`

const trendColor = {
  [Trend.Up]: 'var(--up-9)',
  [Trend.Down]: 'var(--down-9)',
  [Trend.Neutral]: 'var(--neutral-9)',
}
